"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.chat-thread-sharing.disabled': 'Chat thread sharing feature is not available in your current plan.',
};
